import { SET_SERVICE } from 'redux/actions/types';
const initialState = {
  service: {},
};
export default (state = initialState, action) => {
  switch (action.type) {
    case SET_SERVICE:
      return {
        ...state,
        service: action.payload,
      };
    default:
      return state;
  }
};
